<template>
  <div ref="whole_page">
    <vx-card class="w-full mb-6">
      <div>
        <vs-tabs v-model="activeTab">
          <vs-tab label="Assessment">
            <div class="tab-text">
            </div>
          </vs-tab>
          <vs-tab label="Overview">
            
          </vs-tab>
        </vs-tabs>
        <div v-if="activeTab == 1"  class="vx-row w-full">
          <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 w-full">
            <label v-if="companyList.length != 0">Company</label>
            <v-select  v-if="companyList.length != 0" ref="companyDropdown" class="w-full mb-2" placeholder="Search / Select Company" :options="companyList" v-model="chartCompanyDropdown" @input="clearChartData" @search:focus="clearChartData"></v-select>
            
            <label>Module</label>
            <v-select ref="chartmoduleDropdown" class="w-full mb-2" placeholder="Search / Select Module" :options="modules" v-model="chartmoduleDropdown" @input="clearChartData" @search:focus="clearChartData"></v-select>
          </div>
        </div>
        <div v-if="activeTab == 0" class="vx-row w-full">
          <div class="vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 w-full">
            <label v-if="companyList.length != 0">Company</label>
            <v-select v-if="companyList.length != 0" ref="companyDropdown" class="w-full mb-2"
              placeholder="Search / Select Company" :options="companyList" v-model="companyDropdown" @input="clearStudents"
              @search:focus="clearStudents"></v-select>
        
            <label>Module</label>
            <v-select ref="moduleDropdown" class="w-full mb-2" placeholder="Search / Select Module" :options="modules"
              v-model="moduleDropdown" @input="clearStudents" @search:focus="clearStudents"></v-select>
          </div>
          <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-2/3 xl:w-2/3">
            <label>Search Options</label>
            <div class="vx-row w-full">
              <div class=" vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
              <div class="mb-2 info-next-to-checkcss">
                <vs-checkbox v-model="criteria.showAllStudents" color="success">Show All students</vs-checkbox>
                <vx-tooltip text='Students with any status (Whether they have somethnig to assess or not)' position="bottom"
                  class="info-icon-on-module" delay=".3s">
                  <feather-icon svgClasses="h-6 w-6" class="cursor-pointer" icon="InfoIcon">
                  </feather-icon>
                </vx-tooltip>
              </div>
              <div class="mb-2">
                <vs-checkbox v-model="criteria.showAllStudentsThatReachedEndTask" color="success">Show Students that has reached
                  end task</vs-checkbox>
              </div>
              <div class="mb-2">
                <vs-checkbox v-model="criteria.showCompetent" color="success">Include Competent</vs-checkbox>
              </div>
              <div class="mb-2">
                <vs-checkbox v-model="criteria.onlyAssigned" color="success">Only Show Assigned</vs-checkbox>
              </div>
            </div>
            <div class=" vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        
              <div class="mb-2">
                <vs-checkbox v-model="criteria.showNotYetCompetent" color="success">Include Not Yet Compentent</vs-checkbox>
              </div>
              <div class="mb-2">
                <vs-checkbox v-model="criteria.firstTimeAssessment" color="success">First Time Assessment</vs-checkbox>
              </div>
              <div class="mb-2">
                <vs-checkbox v-model="criteria.remedialReturned" color="success">Remedial Returned</vs-checkbox>
              </div>
            </div>
            </div>
        
            <div style="justify-content:flex-end; display: flex;" class="self-center vx-col w-full">
              <vs-button :disabled="!moduleDropdown" vs-align="center" class="shadow" color="success"
                @click="listModuleStudents">Search</vs-button>
            </div>
        
          </div>
        </div>
      </div>
      <div v-if="activeTab == 0" v-show="!isStudentListHidden">
        <vs-divider>Students</vs-divider>
        <vs-table  ref="studentTable" class="vs-con-loading__container" stripe pagination single @selected="getTaskProgress"  :max-items="criteria.pageSize" search :data="students" > <!-- @sort="handleSort" -->

          <template slot="thead">
            <vs-th sort-key="studentFullName" >Name</vs-th>
            <vs-th sort-key="studentIdNumber" >ID Number</vs-th>
            <vs-th sort-key="studentMobile" >Mobile</vs-th>
            <vs-th sort-key="studentEmail" >Email</vs-th>
            <vs-th sort-key="numQueries" >Queries</vs-th>
            <vs-th sort-key="studentTasks" >Tasks At Student</vs-th>
            <vs-th sort-key="moduleStatusId" >Status</vs-th>
            <vs-th sort-key="signedAssessorFeedback" >Feedback</vs-th>
            <vs-th sort-key="logbookId" >Logbook</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="student" :key="indextr" v-for="(student, indextr) in data">

              <vs-td :data="data[indextr].studentFullName">
                {{ student.studentFullName }}
              </vs-td>

              <vs-td :data="data[indextr].studentIdNumber">
                {{ student.studentIdNumber }}
              </vs-td>

              <vs-td :data="data[indextr].studentMobile">
                {{ student.studentMobile }}
              </vs-td>

              <vs-td :data="data[indextr].studentEmail">
                {{ student.studentEmail }}
              </vs-td>

              <vs-td :data="data[indextr].statusName">
                <vs-chip :color="getQueriesColor(student.numQueries)"><strong>{{ student.numQueries }}</strong></vs-chip>
              </vs-td>

              <vs-td :data="data[indextr].studentTasks">
                <vs-chip v-if="student.studentTasks" color="success"> <strong>{{ student.studentTasks }}</strong></vs-chip>
                <vs-chip v-else color="success"> 0 <strong></strong></vs-chip>
              </vs-td>

              <vs-td :data="data[indextr].lastTaskCompleted" style="text-align:center">
                <div v-if="student.numQueries">
                  <vs-chip v-if="student.lastTaskCompleted" color="danger"> <strong>Query</strong></vs-chip>
                </div>
                <div v-else-if="student.moduleStatusId == 1 || student.moduleStatusId == 2 || student.moduleStatusId == 9">
                  <vs-chip v-if="student.lastTaskCompleted" color="success"> <strong>Completed</strong></vs-chip>
                  <vs-chip v-else color="danger"> Busy <strong></strong></vs-chip>
                </div>
                <div v-else>
                  <vs-chip v-if="student.moduleStatusId == 6"  color="success"><strong>{{student.moduleStatusName}}</strong></vs-chip>
                  <vs-chip v-else-if="student.moduleStatusId == 14" color="danger"><strong>Not Yet Competent</strong></vs-chip>
                  <vs-chip v-else-if="student.moduleStatusId != 10 && student.moduleStatusId != 5"  color="success"><strong>{{student.moduleStatusName}}</strong></vs-chip>
                  <vs-chip v-else-if="student.moduleStatusId == 10"  color="success"><strong>Competent</strong></vs-chip>
                  <vs-chip v-else-if="student.moduleStatusId == 5" color="success"><strong>All Summative Assessments Submitted</strong></vs-chip>
                </div>
              </vs-td>

              <vs-td  :data="data[indextr].signedAssessorFeedback">
                <div v-if="student.signedAssessorFeedback">
                  <vs-button size="small" class="shadow" color="success" @click.prevent.stop="generateAssessorFeedback(student.moduleId, student.studentId,student.studentFullName)">Generate Assessor Feedback</vs-button>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].logbookId">
                <vs-button v-if="student.logbookId"  size="small" icon-pack="feather" icon="icon-edit-2" @click.prevent.stop="signStudentLogBook(student.logbookId)" ></vs-button>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <vx-card id="taskProgressCard" class="mb-6" :title="studentTasksCardTitle" v-if="activeTab == 0" v-show="showTaskProgress">
      <vs-table ref="taskProgressCard" stripe class="vs-con-loading__container" single @selected="handelSelectedTaskFromProgress" pagination :max-items="tasksPerPage" search :data="taskProgress">
        <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
          
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col xs:w-full sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ studentTasks.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : studentTasks.length }} of {{ studentTasks.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="tasksPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
          </vs-dropdown>

          <div class="flex flex-wrap-reverse items-center vx-col xs:w-full sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
            <div id="TaskProgressRefreshButton" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" @click="refreshTaskProgress">
              <feather-icon icon="RefreshCcwIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-success">Refresh</span>
            </div>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="task">Task</vs-th>
          <vs-th sort-key="type">Type</vs-th>
          <vs-th sort-key="dateCompleted">Date Completed</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th sort-key="count">Task Count</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">

            <vs-td :data="data[indextr].task">
              {{ task.task }}
            </vs-td>

            <vs-td :data="data[indextr].taskType">
              {{ task.type }}
            </vs-td>

            <vs-td :data="data[indextr].dateCompleted">
              {{ (task.dateCompleted != '0001-01-01T00:00:00' ) ? task.dateCompleted.replace("T", " ").split('.')[0] : ""}}
            </vs-td>

            <vs-td :data="data[indextr].status">
              <vs-chip v-if="task.statusId && task.statusId != 1" :color="getStatusColor(task.statusId)"> {{ task.status}} </vs-chip>
              <vs-chip v-else-if="task.statusId == 1" :color="getStatusColor(task.statusId)"> {{ 'Waiting to be Assessed' }} </vs-chip>
              <vs-chip v-else> {{ task.status}} </vs-chip>
            </vs-td>

            <vs-td :data="data[indextr].count">
              {{ task.count}}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
      <div class="vx-row">
        <vs-button color="warning" type="filled" class="mb-2 ml-3" @click="competentPopUp()">Not Yet Competent</vs-button>
      </div>

      
    </vx-card>
    <vx-card id="studentTaskTable" class="mb-6" :title="studentTasksCardTitle" v-if="activeTab == 0" v-show="!isStudentTasksListHidden">
      <div class="mb-3" v-if="(taskType == 9 || taskType == 3) && !isSurvey">
        <h6><strong>{{`Passing Percentage: ${passPercentage}%`}}</strong></h6>
      </div>
      <vs-table ref="studentTaskTable" stripe class="vs-con-loading__container" single @selected="handleSelectedTask" pagination :max-items="tasksPerPage" search :data="studentTasks">
        <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
          
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col xs:w-full sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ studentTasks.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : studentTasks.length }} of {{ studentTasks.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="tasksPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
          </vs-dropdown>

          <div class="flex flex-wrap-reverse items-center vx-col xs:w-full sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
            <div id="TaskViewRefreshButton" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" @click="refreshTasks">
              <feather-icon icon="RefreshCcwIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-success">Refresh</span>
            </div>
          </div>

          <div class="self-center vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
            <label>Search Options</label>
            <div class="mb-4">
              <vs-checkbox v-model="showOnlyAssesableTasks"  color="success">Show only Actionable Tasks</vs-checkbox>
            </div>
          </div>
        </div>


        <template slot="thead">
          <vs-th sort-key="taskDisplayId">Task Name</vs-th>
          <vs-th sort-key="taskType">Type</vs-th>
          <vs-th sort-key="completedDate">Date Completed</vs-th>
          <vs-th v-if="(taskType == 9 || taskType == 3) && !isSurvey" sort-key="achievedMarks">Percent Achieved</vs-th>
          <vs-th sort-key="statusName">Status</vs-th>
          <vs-th sort-key="remedialTimer">Remedials</vs-th>
          <vs-th sort-key="remedialCount">Remedial Count</vs-th>
          <vs-th sort-key="assessorName">Assessor</vs-th>
          <vs-th ></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">

            <vs-td :data="data[indextr].taskDisplayId">
              {{ task.taskDisplayId + " : " + task.taskName }}
            </vs-td>

            <vs-td :data="data[indextr].taskType">
              {{ task.taskType }}
            </vs-td>

            <vs-td :data="data[indextr].completedDate">
              {{ (task.completedDate != null && task.completedDate != undefined) ? task.completedDate.replace("T", " ").split('.')[0] : ""}}
            </vs-td>

            <vs-td v-if="(taskType == 9 || taskType == 3) && !isSurvey" :data="data[indextr].achievedMarks">
              <vs-chip v-if="task.totalMarks" :color="task.totalMarks >= task.passPercentage ?'success':'danger'">{{`${(task.totalMarks)}%`}}</vs-chip>
              <vs-chip v-else color="warning">No Marks Recorded</vs-chip>
            </vs-td>           

            <vs-td :data="data[indextr].statusName">
              <vs-chip v-if="task.statusId && task.statusId != 1" :color="getStatusColor(task.statusId)">{{ task.statusDisplayName}}</vs-chip>
              <vs-chip v-else-if="task.statusId == 1" :color="getStatusColor(task.statusId)"> {{ 'Waiting to be Assessed' }} </vs-chip>
              <vs-chip v-else color="danger">Not Completed</vs-chip>
            </vs-td>

            <vs-td v-if="data[indextr].remedialTimer || data[indextr].remedialTimer == 0" :style="task.remedialTimer > 7 ? 'color:red' : ''" :data="data[indextr].remedialTimer">
              {{7-task.remedialTimer}} {{7-task.remedialTimer != 1 ? 'Days Left' : 'Day Left' }}
            </vs-td>

            <vs-td v-if="!data[indextr].remedialTimer && data[indextr].remedialTimer != 0" :data="data[indextr].remedialTimer">
            </vs-td>

            <vs-td :data="data[indextr].remedialCount">
              <p>{{` ${task.remedialCount}/${task.remedialCount >2 ? `${task.remedialCount}` : '2'}`}}</p>
            </vs-td>

            <vs-td :data="data[indextr].assessorName">
              {{ task.assessorName}}
            </vs-td>

            <vs-td  v-if="(task.assessorId != userIdFromLocalStorage && task.assessorId)" :data="data[indextr].assessorId">
              <vs-button size="small" vs-align="center" class="shadow" color="success"  @click.prevent.stop="openPopup(data[indextr].logId)"  v-if="(task.assessorId != userIdFromLocalStorage && task.assessorId)">Assign to Me</vs-button>
            </vs-td>

          </vs-tr>

        </template>
      </vs-table>
      <vs-divider class="mb-6 pt-0"></vs-divider>
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#studentInfoCard'" @click="cancelTaskView">Close</vs-button>
        </div>
      </div>

      <vs-popup id="cellViewPopup" title="Are you sure you want to unassign this Assessor from the assessment?" :active.sync="rejectPopupConfirm">
        <div>
          Please provide a reason for unassigning this Assessor
          <vs-textarea class="mt-1" name="reasonText" id="reasonText" v-model="reasonText"></vs-textarea>
          <div class="float-right mt-1">
              <vs-button color="success" :disabled="!reasonText" @click="assignTaskToMe">Yes</vs-button>
              <vs-button color="danger" class="ml-1" @click="rejectPopupConfirm = false">No</vs-button>          
          </div>
        </div>
      </vs-popup>

      <vs-popup id="AssessorFeedbackDocument" fullscreen :button-close-hidden="true" title="Assessor Feedback Preview" :active.sync="assessorFeedbackPreviewPopup">
        <div class="assessorFeedbackSize" style="width: fit-content; margin:auto">
          <assessorFeedbackDocument v-if="assessorFeedbackPreviewPopup" :assessorFeedbackData="assessorFeedbackData" :taskResults="taskResults" :questionList="questionList" :assessorFeedback="assessorFeedback" @closeTab="getVarCCS" />
        </div>
      </vs-popup>

    </vx-card>

    <div v-if="activeTab == 1">
          <div v-show="activeTab == 1 && chartsVisable" class="side-margin mt-4">
            <div class="vx-row w-full mt-2">
              <div class="vx-col w-full">
                <vx-card class="w-full mb-3" >
                  <Loading style="height:250px" v-if="!barchartVisable"></Loading>
                  <chartjs-bar-chart  v-if="barchartVisable"  :options="barChartOptions" :data="barChartData" ></chartjs-bar-chart>
                </vx-card>
              </div>
            </div>
            <div class="vx-row w-full mt-3 " style="min-height: 450px;">
              <div class="vx-col mb-3 sm:w-full md:w-full lg:w-1/2 xl:w-1/2 w-full">
                <vx-card  class="mb-2 h-full" code-toggler>
                  <Loading style="height:250px" v-if="!polarchartVisable" ></Loading>
                  <chartjs-polar-area-chart  v-if="polarchartVisable" :data="polarChartdata" :options="polarChartoptions" ></chartjs-polar-area-chart>
                  <template slot="codeContainer">
 Assessed: Competent (Assessed, Moderated, Evaluated) Status and UP
 Busy: Started with Module (started)
 ReadyToAssess: All formative tasks, All Sumative Tasks Submitted
 NotYetStarted: Assigned students (assigned status)
 NotYetCompetent: Not yet competent status for this module
                  </template>
                </vx-card>
              </div>
              <div class="vx-col mb-3 sm:w-full md:w-full lg:w-1/2 xl:w-1/2 w-full ">
                <vx-card :title="`Total: ${piechartTotal ? piechartTotal : 'Loading...' }`" class="mb-2 h-full" >
                  <Loading style="height:250px" v-if="!piechartVisable" ></Loading>
                  <chartjs-doughnut-chart @DoughnutChartClicked="graphClickEvent" v-if="piechartVisable" :data="pieChartdata" :options="pieChartoptions" ></chartjs-doughnut-chart>
                </vx-card>
              </div>
            </div>
            <div class="vx-row w-full mt-6">
              <div class="vx-col w-full">
                <vx-card  id="selectedStatusTable" v-show="selectedStatusTableData.length" :title="`Students With Status: ${selectedStatus}`">
                  <vs-table ref="selectedStatusTable" stripe class="vs-con-loading__container" single pagination :max-items="tasksPerPage" search :data="selectedStatusTableData">
                    <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
                  
                      <!-- ITEMS PER PAGE -->
                      <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col s:w-1/3 xs:w-full sm:w-full md:w-1/3 lg:w-1/4 xl:w-1/6">
                        <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
                          <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ selectedStatusTableData.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : selectedStatusTableData.length }} of {{ selectedStatusTableData.length }}</span>
                          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/> 
                        </div>
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="tasksPerPage=10">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="tasksPerPage=15">
                          <span>15</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="tasksPerPage=20">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="tasksPerPage=25">
                          <span>25</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="tasksPerPage=50">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="tasksPerPage=100">
                          <span>100</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  
                    <template slot="thead">
                      <vs-th sort-key="userFullName">User Full Name</vs-th>
                      <vs-th sort-key="email">Email</vs-th>
                      <vs-th sort-key="mobile">Mobile</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :data="user" :key="indextr" v-for="(user, indextr) in data"> 
                  
                        <vs-td :data="data[indextr].userFullName">
                          {{ user.userFullName }}
                        </vs-td> 

                        <vs-td :data="data[indextr].email">
                          {{ user.email }}
                        </vs-td> 
                  
                        <vs-td :data="data[indextr].mobile">
                          {{ user.mobile }}
                        </vs-td> 

                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </div>
            </div>
            <div class="vx-row w-full mt-3 ">                              
              <div class="vx-col mb-3 sm:w-full md:w-full lg:w-1/2 xl:w-1/2 w-full ">                 
              <vx-card :title="`Additional Data:`" class="mb-2 h-full" >                   
                <Loading style="height:250px" v-if="logbookCountLoading" ></Loading>                   
                <div v-else>
                  <h3>{{`Amount Of Signable Logbooks: ${amountOfLogbooks}`}}</h3>
                </div>                 
                </vx-card>               
              </div>             
            </div>
          </div>
        </div>
        <vs-popup
        id="logbook-preview-popup"
        title="Logbook Preview"
        :active.sync="showLogbookPreview"
        fullscreen
      >
      <div v-if="true" class="vx-row">
        <div class="vx-col w-full">
          <div id="html-content" v-html="logbookHtml"></div>
          <div class="vx-row mt-3">
            <vs-spacer />
            <div class="vx-col">
              <vs-button @click="approveLogbook" ref="approve_logbook_btn" class="vs-con-loading__container" color="success">Sign Logbook</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import assessorFeedbackDocument from "../components/AssessorFeedbackDocument.vue";
  import 'animate.css';

  import ChartjsPolarAreaChart from "../../components/chart/ChartjsPolarAreaChart.vue"
  import ChartjsDoughnutChart from "../../components/chart/ChartjsDoughnutChart.vue"
  import ChartjsBarChart from "../../components/chart/ChartjsBarChart.vue"
  import Loading from "../../components/Loading.vue"

  export default {
    components: {
      'v-select': vSelect,
      assessorFeedbackDocument,
      ChartjsPolarAreaChart,
      ChartjsDoughnutChart,
      ChartjsBarChart,
      Loading
    },
    data() {
      return {
        pageSize: 10,
        moduleDropdown: null,
        loadingColor:'#fff',
        selected: [],
        tasksPerPage: 10,
        isMounted: false,
        isStudentListHidden: true,
        isStudentTasksListHidden: true,
        modules: [],
        students: [],
        studentTasks: [],
        formData: {
          id: 0,
          description: ""
        },
        mode: "",
        studentTasksCardTitle: "",
        counterDanger: false,
        selectedStudent: null,
        criteria: {
          pageSize: 10,
          pageNumber: 0,
          sortKey: "",
          sortOrder: "",
          searchPhrase: "",
          showInactive: false,
          showAllStudents: false,
          showAllStudentsThatReachedEndTask:false,
          showCompetent:true,
          showNotYetCompetent:true,
          remedialReturned:false,
          firstTimeAssessment:false,
          onlyAssigned:false
        },
        showOnlyAssesableTasks: true,
        taskProgress:[],
        showTaskProgress:false,
        userIdFromLocalStorage:0,
        selectedTaskIdPopupData:null,
        rejectPopupConfirm:false,
        reasonText:"",
        companyList:[],
        companyDropdown:null,
        taskType:null,
        passPercentage:null,
        isSurvey:false,
        assessorFeedback:{
          studentId:0,
          isCompetent:false,
          hasCompletedQuizzes:false,
          hasCompletedJournals:false,
          hasCompletedLogbook:false,
          hasCompletedPersonalInfo:false,
          hasCompletedAssessmentPrep:false,
          hasCompletedAssessmentPlan:false,
          hasCompletedDeclarationofAuth:false,
          logId:0,
          assessorFeedbackAnswers:[]
        },
        assessorFeedbackAnswer:{
          id:0,
          agree:null,
          answer:null
        },
        questionList:[],
        popupHtml:``,
        freeTextPopup:``,
        lastIndex:0,
        assessorFeedbackPreviewPopup:false,
        assessorFeedbackData:{},
        selectedModuleId:0,
        selectedStudentId:0,
        taskResults:{},
        varccsItems:[],
        varccHTML:"",
        varccComment:"",
        studentModuleId:0,
        reviewQuestions:[],
        reviewHTML:"",
        activeTab:0,
        chartmoduleDropdown:null,
        barchartVisable:false,
        piechartVisable:false,
        polarchartVisable:false,
        barChartData:{
          labels: [],
          datasets: [{
            label: "",
            backgroundColor: [],
            data: []
          }]
        },
        barChartOptions:{
          legend: { 
            display: false,
            labels: {
              usePointStyle: true,
              boxWidth: 20
            },
          },
          title: {
            display: true,
            text: 'Assessed Students this past week'
          },
          responsive: true,
          maintainAspectRatio: false
        },
        pieChartdata: {
          labels: [],
          datasets: []
        },
        pieChartoptions: {
          title: {
            display: true,
            text: ['Amount of Students within a Status','(Click to view)']
          },
          legend:{
            position:'right',
            labels: {
              usePointStyle: true,
              boxWidth: 20
            },
          },
          responsive: true,
          maintainAspectRatio: false
        },
        piechartTotal:0,
        polarChartdata:{
          labels: [],
          datasets: [{
            label: "",
            backgroundColor: [],
            data: []
          }]
        },
        polarChartoptions:{
          legend: { 
            position:'right',
            labels: {
              usePointStyle: true,
              boxWidth: 20
            },
          },
          scale: {
            display: false
          },
          title: {
            display: true,
            text: 'Status Overview'
          },
          responsive: true,
          maintainAspectRatio: false
        },
        selectedStatus:"",
        selectedStatusTableData:[],
        chartCompanyDropdown:null,
        chartsVisable:false,
        logbookHtml:"",
        showLogbookPreview:false,
        logbookCountLoading:true,
        amountOfLogbooks:0,
      }
    },
    watch:{
      chartmoduleDropdown: function(){
        if(this.chartmoduleDropdown){
          this.chartsVisable = true;
          this.getLogbookCount();
        }
        else{
          this.chartsVisable = false;
        }
        if(!this.barChartData.datasets.length){
          this.getbarChartData();
        }
        if(!this.pieChartdata.datasets.length){
          this.getPieChartData();
        }
        if(!this.polarChartdata.datasets.length){
          this.getpolarChartdata();
        }
      },
      showOnlyAssesableTasks: function(){
        this.refreshTasks();
      },
      'criteria.pageNumber':function(){
        var self = this;
        self.listModuleStudents();
      },
      companyDropdown:function(){
        if(this.companyDropdown){
          this.moduleDropdown = null;
        }
        this.loadModules();
      },
      chartCompanyDropdown:function(){
        if(this.chartCompanyDropdown){
          this.chartmoduleDropdown = null;
        }
        if(!this.chartCompanyDropdown){
          this.chartmoduleDropdown = null;
        }
        this.loadModules();
      }
    },
    computed: {
      currentStudentPage() {
        if (this.isMounted) {
          return this.$refs.studentTable.currentx;
        }
        return 0;
      },
      currentTaskPage() {
        if (this.isMounted) {
          return this.$refs.studentTaskTable.currentx;
        }
        return 0;
      },
      isDisabled: function() {
        return !(this.formData.description);
      },
    },
    methods: {
      initValues() {
        this.formData.id = 0;
        this.formData.description = "";
        this.mode = "";
        this.isStudentListHidden = true;
        this.errors.clear();
        this.companyList=[];
      },
      getStatusColor(statusId) {
        if(statusId == 6)
          return 'primary';
        else if(statusId == 3|| statusId == 2 || statusId == 15)
          return 'success';
        else if(statusId == 5 || statusId == 10)
          return 'danger';
        else if(statusId == 0)
          return 'light'
        else if(statusId == 1){
          return 'danger'
        }
        else
          return 'warning'; 
      },
      getQueriesColor(numQueries) {
        if(numQueries == 0)
          return 'success';
        else
          return 'danger';
      },
      cancelAdd() {
        this.initValues();
        this.isStudentListHidden = true;
      },
      listModuleStudents() {
        const self = this;
        self.showTaskProgress = false;
        self.isStudentTasksListHidden = true;
        
        if(self.moduleDropdown){
          self.isStudentListHidden = false;
          self.showLoadingOnElement("studentTable", 1, "corners");
          var onSuccess = function (response) {
            self.students = [];
            if(self.criteria.pageNumber > 1)
              self.students[((self.criteria.pageNumber - 1) * self.pageSize) - 1] = {};

            self.students = self.students.concat(response.data.records);

            if(response.data.count > (self.criteria.pageNumber * self.pageSize))
              self.students[response.data.count - 1] = {};
            setTimeout(() => {
              self.$refs.studentTable.currentx = 1;
            }, 200);
            
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.studentTable.$el);
          };
          if(self.companyDropdown){
            self.$ajaxPost(self, "AssessorModule/ListModuleStudentsSst?moduleId=" + self.moduleDropdown.value +"&companyId="+self.companyDropdown.value, self.criteria, onSuccess, onFinally);
          }
          else{
            self.$ajaxPost(self, "AssessorModule/ListModuleStudentsSst?moduleId=" + self.moduleDropdown.value +"&companyId=0", self.criteria, onSuccess, onFinally);
          }
          
        }
      },
      saveData() {
        this.initValues();
        this.loadData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
      },
      loadModules(){
        var self = this;
        if(this.chartCompanyDropdown || self.activeTab == 1){
          self.showLoadingOnElement("chartmoduleDropdown", 0.45, "corners");
        }
        else {
          self.showLoadingOnElement("moduleDropdown", 0.45, "corners");
        }
        function compare( a, b ) {
          if ( a.label < b.label ){
            return -1;
          }
          if ( a.label > b.label ){
            return 1;
          }
          return 0;
        }
        var onSuccess = function (response) {
          self.modules = response.data.map((item) => {return {label: item.text, value: item.value} });
          self.modules.sort( compare );
        };

        var onFinally = function () {
          if(self.$refs.moduleDropdown){
            self.$vs.loading.close(self.$refs.moduleDropdown.$el);
          }
          if(self.$refs.chartmoduleDropdown){
            self.$vs.loading.close(self.$refs.chartmoduleDropdown.$el);
          }
        };
        if(self.companyDropdown){
          self.$ajaxGet(self, "AssessorModule/GetAssessorModulesByCompany?CompanyId="+ self.companyDropdown.value, onSuccess, onFinally);
        }
        else if(self.chartCompanyDropdown){
          self.$ajaxGet(self, "AssessorModule/GetAssessorModulesByCompany?CompanyId="+ self.chartCompanyDropdown.value, onSuccess, onFinally);
        }
        else{
          self.$ajaxGet(self, "AssessorModule/GetAssessorModules", onSuccess, onFinally);
        }
        
      },
      clearStudents() {
        var self = this;
        self.students = [];
        self.isStudentListHidden = true;
        self.studentTasks = [];
        self.isStudentTasksListHidden = true;
        self.taskProgress =[];
        self.showTaskProgress = false;
      },
      handleSelectedStudent(student) {
        var self = this;
        self.selectedStudent = student;
        self.studentTasksCardTitle = "Tasks for " + student.studentFullName;
        self.showLoadingOnElement("studentTaskTable", 1, "corners");

        var onSuccess = function (response) {
          self.taskType = null;
          self.passPercentage = null;
          self.studentTasks = response.data;
          if(self.studentTasks.length != 0){
            self.taskType = self.studentTasks[0].taskTypeId;
            self.isSurvey = self.studentTasks[0].survey;
            self.passPercentage = self.studentTasks[0].passPercentage;
          }
          self.isStudentTasksListHidden = false;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.studentTaskTable.$el);
          
        };

        self.$ajaxGet(self, "AssessorModule/ListStudentTasks?studentId=" + student.studentId + "&moduleId=" + student.moduleId + "&showOnlyAssesableTasks=" + self.showOnlyAssesableTasks +"&taskId=" + student.taskId, onSuccess, onFinally);
      },
      handelSelectedTaskFromProgress(selected){
        var self = this;
        self.studentTasks = [];
        self.showTaskProgress = false;
        self.isStudentTasksListHidden = false;
        self.selectedStudent.taskId = selected.taskId;
        self.handleSelectedStudent(self.selectedStudent);
      },
      refreshTasks() {
        var self = this;
        self.showLoadingOnElement("studentTaskTable", 1, "corners");

        var onSuccess = function (response) {
          if(!self.showOnlyAssesableTasks){
            self.studentTasks = response.data;
          }
          else{
            self.studentTasks = response.data.filter(x=>x.broken != true);
          }
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.studentTaskTable.$el);
        };

        self.$ajaxGet(self, "AssessorModule/ListStudentTasks?studentId=" + self.selectedStudent.studentId + "&moduleId=" + self.selectedStudent.moduleId + "&showOnlyAssesableTasks=" + self.showOnlyAssesableTasks +"&taskId=" + self.selectedStudent.taskId, onSuccess, onFinally);
      },
      cancelTaskView(){
        var self = this;
        self.showTaskProgress = !self.showTaskProgress;
        self.isStudentTasksListHidden = !self.isStudentTasksListHidden;
        self.refreshTaskProgress();
      },
      handleSelectedTask(task) {
        var self = this;

        self.showLoadingOnElement("studentTaskTable", 1, "corners");

        var onSuccess = function(response){
          if(response.data === true){
            let routeData = self.$router.resolve({ path: '/assessor/ViewTask', query: { TaskLogId: task.logId} });
            window.open(routeData.href, '_blank');
          }
        }

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.studentTaskTable.$el);
        };

        self.$ajaxPost(self, "AssessorModule/AssignTask?id=" + task.logId, null, onSuccess, onFinally);
          
      },
      showLoadingOnElement(element, scale, type){
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      getTaskProgress(student){
        var self = this;
        self.selectedModuleId = student.moduleId;
        self.selectedStudentId = student.id;
        self.taskResults.fullname = student.studentFullName;
        if(!self.showTaskProgress){
          self.showLoadingOnElement("studentTable", 1, "corners");
        }
        else{
          self.showLoadingOnElement("taskProgressCard", 1, "corners");
        }
        self.selectedStudent = student;
        self.isStudentTasksListHidden = true;
        self.studentTasksCardTitle = "Tasks for " + student.studentFullName;

        var onSuccess = function(response){
          self.taskProgress = response.data;
          self.showTaskProgress = true;
          var scrollOptions = {
            easing: "ease-in",
            offset: 0,
            force: true,
            cancelable: false,
            x: false,
            y: true
          };
        
          //Scroll Here 
          setTimeout(() => {
            self.$scrollTo(
              document.getElementById("taskProgressCard"),
              500,
              scrollOptions
            );
          }, 300);
        }

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.studentTable.$el);
          self.$vs.loading.close(self.$refs.taskProgressCard.$el);
        };

        self.$ajaxGet(self, "Assessor/AssessmentProgress?studentId=" + student.studentId + "&moduleId=" + student.moduleId, onSuccess, onFinally);
      },
      refreshTaskProgress(){
        var self = this;
        self.showLoadingOnElement("taskProgressCard", 1, "corners");

        var onSuccess = function(response){
          self.taskProgress = response.data;
        }

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.taskProgressCard.$el);
        };

        self.$ajaxGet(self, "Assessor/AssessmentProgress?studentId=" + self.selectedStudent.studentId + "&moduleId=" + self.selectedStudent.moduleId, onSuccess, onFinally);
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      handleSearch(searchPhrase) {
        var self = this;

        if(searchPhrase.length >= 3){
          self.criteria.searchPhrase = searchPhrase;

          self.listModuleStudents();
        }
        else if (searchPhrase == ""){
          self.criteria.searchPhrase = searchPhrase;
          self.listModuleStudents();
        }
      },
      handleChangePage(pageNumber) {
        var self = this;
        if(pageNumber > 0) {
          self.criteria.pageNumber = pageNumber;
        }
      },
      openPopup(selectTaskId){
        var self = this;
        self.reasonText ="",
        self.selectedTaskIdPopupData = selectTaskId;
        self.rejectPopupConfirm = true;
      },
      assignTaskToMe(){
        var self = this;
        self.rejectPopupConfirm = false;
        var selectLogId = self.selectedTaskIdPopupData;
        self.showLoadingOnElement("taskProgressCard", 1, "corners");
        var onSuccess = function(response){
          self.refreshTasks();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Assessor ReAssigned",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check'
          });
        }

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.taskProgressCard.$el);
        };
        self.$ajaxGet(self, "Assessor/AssignToMe?logId="+ selectLogId +"&reason="+self.reasonText, onSuccess, onFinally);
      },
      getCompany(){
        var self = this;
        var onSuccess = response =>{
          self.companyList = response.data.map(x=>{return{label:x.text,value:x.value}});
        }
        self.$ajaxGet(self,"Company/CompanyListByAssessor?assessorId="+self.userIdFromLocalStorage , onSuccess);
      },
      generateAssessorFeedback(moduleId, studentId,studentName){
        var self = this;
        self.selectedModuleId = moduleId;
        self.selectedStudentId = studentId;
        self.taskResults.fullname = studentName;
        self.showFinalJudgeMentPopup();
        
      },
      firstReviewPopUp(){
      var self = this;
      self.$swal({
        title: 'Feedback',
        icon: 'info',
        html: `
        <h4>Check the following</h4>
        <div class="popupCustomContent mb-3">
          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackQuizzes" name="Quizzes" checked>
            <div class="state p-success">
              <label for="FeedbackQuizzes">Quizzes</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackJournals" name="Journals & Case Studies" checked>
            <div class="state p-success">
              <label for="FeedbackJournals">Journals & Case Studies</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackLogbook" name="Workplace Logbook" checked>
            <div class="state p-success">
              <label for="FeedbackLogbook">Workplace Logbook</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackPersonalInformation" name="Learner’s Personal Information" checked>
            <div class="state p-success">
              <label for="FeedbackPersonalInformation">Learner’s Personal Information</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackPreparation" name="Assessment Preparation" checked>
            <div class="state p-success">
              <label for="FeedbackPreparation">Assessment Preparation</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackAssessmentPlan" name="Assessment Plan" checked>
            <div class="state p-success">
              <label for="FeedbackAssessmentPlan">Assessment Plan</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackAuthenticity" name="Declaration of Authenticity" checked>
            <div class="state p-success">
              <label for="FeedbackAuthenticity">Declaration of Authenticity</label><br>
            </div>
          </div>
        </div>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
        },
        showClass: {
          popup: 'animate__animated animate__bounceIn assessment-Questions',
        },
        confirmButtonText:'Next',
        showCancelButton: true,
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,

        preConfirm:(data) =>{
          
          this.assessorFeedback.hasCompletedQuizzes = document.getElementById('FeedbackQuizzes').checked ;
          this.assessorFeedback.hasCompletedJournals = document.getElementById('FeedbackJournals').checked ;
          this.assessorFeedback.hasCompletedLogbook = document.getElementById('FeedbackLogbook').checked ;
          this.assessorFeedback.hasCompletedPersonalInfo = document.getElementById('FeedbackPersonalInformation').checked ;
          this.assessorFeedback.hasCompletedAssessmentPrep = document.getElementById('FeedbackPreparation').checked ;
          this.assessorFeedback.hasCompletedAssessmentPlan = document.getElementById('FeedbackAssessmentPlan').checked ;
          this.assessorFeedback.hasCompletedDeclarationofAuth = document.getElementById('FeedbackAuthenticity').checked ;
          
        },
        }).then((result) => {
          //self.htmlBuilderForassessorFeedbackDocumentQuestions();
          self.addAssessorFeedback();
        });
      },
      showFinalJudgeMentPopup(){
        var self = this;
        self.$swal({
          title: 'Final Judgement',
          icon: 'warning',
          html: `<p class='mb-3'>What is your final judgement on <br> <strong>${self.taskResults.fullname}'s</strong> compentency?</p>`,
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
            cancelButton: 'vs-component vs-button vs-button-warning vs-button-filled',
          },
          showClass: {
            popup: 'animate__animated animate__bounceIn',
          },
          confirmButtonText:'Competent',
          cancelButtonText:'Not Yet Competent',
          showCancelButton: true,
          buttonsStyling: false,
          allowOutsideClick:true,
          allowEnterKey:false,
          allowEscapeKey:false,
        }).then((result) => {
          if (result.isConfirmed) {
            self.assessorFeedback.isCompetent = true;
            self.firstReviewPopUp();
            return;
          }
          else if(!result.isConfirmed){
            self.assessorFeedback.isCompetent = false;
          }
          if(result.isDismissed && result.dismiss!="cancel"){
            return;
          }
          self.firstReviewPopUp();
        });
      },
      addAssessorFeedback(){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");

        var onSuccess = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
          self.assessorFeedbackData = response.data;
          self.assessorFeedbackPreviewPopup=true;
        }
        self.assessorFeedback.moduleId = self.selectedModuleId;
        self.assessorFeedback.studentId = self.selectedStudentId;
        self.$ajaxPost(self, "assessor/FeedbackDocument" , self.assessorFeedback , onSuccess);
      },
      closeTab(){
        var self = this;
        self.assessorFeedbackPreviewPopup = false;
        self.listModuleStudents();
      },
      competentPopUp(){
        var self =this;
        self.$swal({
          title: 'Final Judgement',
          icon: 'warning',
          html: `<p class='mb-3'>Are you sure you want to declare <br> <strong>${self.selectedStudent.studentFullName}</strong> as Not Competent?<br><br>Then please type <strong>Confirm</strong> in the given space</p>`,
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          showLoaderOnConfirm: true,
          preConfirm: (textInput) => {
            if(textInput == "Confirm"){
              self.assessorFeedback.isCompetent = false;
              self.firstReviewPopUp();
            }
            else{
              self.$swal.showValidationMessage(
              `Please type the word Confirm into the given space.`
            )}
          },
          allowOutsideClick: () => !self.$swal.isLoading()
        })
      },
      getVarCCS(){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");

        var onSuccess = response =>{
          self.varccsItems = response.data;
          self.varcPopupHTMLGen();
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxGet(self, `Assessor/varcQuestionsStudentModule/${self.selectedStudentId}/${self.selectedModuleId}` , onSuccess, onFinally);
      },
      varcPopupHTMLGen(){
        var self = this;
        self.assessorFeedbackPreviewPopup  = false;
        self.varccHTML = "";
        self.varccComment = "";
        for (let index = 0; index < self.varccsItems.length; index++) {
          self.varccHTML += `
          <div class="Heading mb-3">
            <p><span>${self.varccsItems[index].id}. </span>${self.varccsItems[index].question}</p>
          </div>
          <div class="vx-row checkbox-relative">
            <div class="pretty p-default p-round p-fill float-left mb-3 vx-col" style="align-self:center;">
              <input type="checkbox" class="check_container" checked id="varcccheck${self.varccsItems[index].id}">
              <div class="state p-success">
                <label for="varcccheck${self.varccsItems[index].id}"> Agree</label><br>
              </div>
            </div>
            <div class="vx-col w-2/3">
              <div class="vs-component vs-con-textarea vs-textarea-primary">
                <textarea placeholder="Description" id="varcccomment${self.varccsItems[index].id}" class="vs-textarea">${self.varccsItems[index].comment ? self.varccsItems[index].comment : ''}</textarea> 
              </div>
            </div>
          </div>
          `;
          self.lastIndex = index;
        }
        self.showpopupVarcCheck();
      },
      showpopupVarcCheck(){
        var self = this;
        self.$swal({
          title: 'VARCCS Evaluation',
          icon: 'info',
          html: `
          <h4>Answer the following</h4>
          <div class="popupCustomContent mb-3">
            ${self.varccHTML}
          </div>`,
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
          },
          showClass: {
            popup: 'animate__animated animate__fadeInDown varccs-evaluation',
          },
          confirmButtonText:'Next',
          showCancelButton: true,
          buttonsStyling: false,
          allowOutsideClick:false,
          allowEnterKey:false,
          allowEscapeKey:false,
          preConfirm:(data) =>{
            for (let index = 0; index < self.varccsItems.length ; index++) {
              var generatedCheckId = `varcccheck${self.varccsItems[index].id}`
              var generatedCommentId = `varcccomment${self.varccsItems[index].id}`
              var check = document.getElementById(generatedCheckId).checked;
              var comment = document.getElementById(generatedCommentId).value;
              self.varccsItems[index].answer = check;
              self.varccsItems[index].comment = comment;
            }
          },
        }).then((result) => {
          self.returnVarccs();
        });
      },
      returnVarccs(){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");

        var onSuccess = response =>{
          self.studentModuleId = response.data;
          self.getReviewQuestions();
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxPost(self, `Assessor/ReturnVarcResponseStudentModule/${self.selectedStudentId}/${self.selectedModuleId}` , self.varccsItems , onSuccess, onFinally);
      },
      getReviewQuestions(){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");
        var onSuccess = response =>{
          self.reviewQuestions = response.data;
          self.varcReviewHtml();
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxGet(self, `Assessor/ReviewQuestions?studentModuleId=${self.studentModuleId}` , onSuccess, onFinally);
      },
      varcReviewHtml(){
        var self = this;
        self.reviewHTML = "";
        for (let index = 0; index < self.reviewQuestions.length; index++) {
          self.reviewHTML += `
          <div class="Heading mb-3">
            <p><span>${self.reviewQuestions[index].questionId}. </span>${self.reviewQuestions[index].question}</p>
          </div>
          <div class="vx-row checkbox-relative">
            <div class="pretty p-default p-round p-fill float-left mb-3 vx-col" style="align-self:center;">
              <input type="checkbox" class="check_container" checked id="varcccheck${self.reviewQuestions[index].questionId}">
              <div class="state p-success">
                <label for="varcccheck${self.reviewQuestions[index].questionId}"> Agree</label><br>
              </div>
            </div>
            <div class="vx-col w-2/3">
              <div class="vs-component vs-con-textarea vs-textarea-primary">
                <textarea placeholder="Description" id="varcccomment${self.reviewQuestions[index].questionId}" class="vs-textarea">${self.reviewQuestions[index].assessorComment ? self.reviewQuestions[index].assessorComment : ''}</textarea> 
              </div>
            </div>
          </div>
          `;
          self.lastIndex = index;
        }
        self.showpopupReview();
      },
      showpopupReview(){
        var self = this;
        self.$swal({
          title: 'Review of the Assessment',
          icon: 'info',
          html: `
          <h4>Answer the following</h4>
          <div class="popupCustomContent mb-3">
            ${self.reviewHTML}
          </div>`,
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
          },
          showClass: {
            popup: 'animate__animated animate__fadeInDown varccs-evaluation',
          },
          confirmButtonText:'Complete',
          showCancelButton: true,
          buttonsStyling: false,
          allowOutsideClick:false,
          allowEnterKey:false,
          allowEscapeKey:false,
          preConfirm:(data) =>{
            for (let index = 0; index < self.reviewQuestions.length ; index++) {
              var generatedCheckId = `varcccheck${self.reviewQuestions[index].questionId}`
              var generatedCommentId = `varcccomment${self.reviewQuestions[index].questionId}`
              var check = document.getElementById(generatedCheckId).checked;
              var comment = document.getElementById(generatedCommentId).value;
              self.reviewQuestions[index].assessorResponse = check;
              self.reviewQuestions[index].assessorComment = comment;
            }
          },
        }).then((result) => {
          self.returnReview();
        });
      },
      returnReview(){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");

        var onSuccess = response =>{
          self.closeTab();
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxPost(self, `Assessor/UpdateReviewAnswers?studentmoduleId=${self.studentModuleId}`, self.reviewQuestions , onSuccess, onFinally);
      },
      getbarChartData(){
        var self = this;

        var onSuccess = response =>{
          this.barChartData = response.data;
          this.barchartVisable = true;
        }
        if(self.chartCompanyDropdown){
          self.$ajaxGet(self, `Assessor/BarChartData?moduleId=${this.chartmoduleDropdown.value}&companyId=${self.chartCompanyDropdown.value}` , onSuccess);
        }
        else{
          self.$ajaxGet(self, `Assessor/BarChartData?moduleId=${this.chartmoduleDropdown.value}` , onSuccess);
        }
      },
      getPieChartData(){
        var self = this;
        var onSuccess = response =>{
          this.pieChartdata = response.data;
          this.piechartVisable = true;
          for (let i = 0; i < response.data.datasets[0].data.length; i++) {
            this.piechartTotal += response.data.datasets[0].data[i];
          }
        }
        if(self.chartCompanyDropdown){
          self.$ajaxGet(self, `Assessor/PieChartData?moduleId=${this.chartmoduleDropdown.value}&companyId=${self.chartCompanyDropdown.value}` , onSuccess);
        }
        else{
          self.$ajaxGet(self, `Assessor/PieChartData?moduleId=${this.chartmoduleDropdown.value}` , onSuccess);
        }
      },
      getpolarChartdata(){
        var self = this;
        var onSuccess = response =>{
          this.polarChartdata = response.data;
          this.polarchartVisable = true;
        }
        if(self.chartCompanyDropdown){
          self.$ajaxGet(self, `Assessor/PolarChartData?moduleId=${this.chartmoduleDropdown.value}&companyId=${self.chartCompanyDropdown.value}` , onSuccess);
        }
        else{
          self.$ajaxGet(self, `Assessor/PolarChartData?moduleId=${this.chartmoduleDropdown.value}` , onSuccess);
        }
      },
      clearChartData(){
        this.piechartVisable = false;
        this.barchartVisable = false;
        this.polarchartVisable = false;
        this.piechartTotal = 0;
        this.pieChartdata.datasets = [];
        this.pieChartdata.labels = [];
        this.barChartData.datasets = [];
        this.barChartData.labels = [];
        this.polarChartdata.datasets = [];
        this.polarChartdata.labels = [];
        this.selectedStatusTableData = [];
        this.chartsVisable=false;
      },
      graphClickEvent(event,item){
        if(item.length && event.target.id =="doughnut-chart"){
          var index = item[0]._index;
          this.selectedStatus = this.pieChartdata.labels[index]
          this.getStudentsByStudentModuleStatus(this.selectedStatus);
        }
      },
      getStudentsByStudentModuleStatus(selectedStatus){
        var self = this;
        self.showLoadingOnElement("selectedStatusTable",1,"corners");

        var onSuccess = response =>{
          self.selectedStatusTableData = response.data;
          var scrollOptions = {
            easing: "ease-in",
            offset: -500,
            force: true,
            cancelable: true,
            x: false,
            y: true
          };
          setTimeout(() => {
            this.$scrollTo(
              document.getElementById("selectedStatusTable"),
              300,
              scrollOptions
            );
          }, 300);
          if(self.$refs.selectedStatusTable){
            self.$vs.loading.close(self.$refs.selectedStatusTable.$el);
          }
        }

        if(self.chartCompanyDropdown){
          self.$ajaxGet(self, `Assessor/GetStudentsWith?status=${selectedStatus}&moduleId=${this.chartmoduleDropdown.value}&companyId=${self.chartCompanyDropdown.value}` , onSuccess);
        }
        else{
          self.$ajaxGet(self, `Assessor/GetStudentsWith?status=${selectedStatus}&moduleId=${this.chartmoduleDropdown.value}` , onSuccess);
        }
        
      },
      signStudentLogBook(logbookId){
        const self = this;
        self.selectedLogbook = logbookId;
        self.showLoadingOnElement('whole_page', 1, 'material');

        var onSuccess = function (response) {
          self.showLogbookPreview=true;
          self.logbookHtml = response.data;
        };

        var onFinally = response =>{
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
        self.$ajaxGet(self, `Logbook/GenerateLogbookPreviewLogbookId?logbookId=${logbookId}`, onSuccess, onFinally);
      },
      approveLogbook() {
      const self = this;
        self.showLoadingOnElement("approve_logbook_btn", 0.45, "material");

        var onSuccess = function(response) {
          self.showLogbookPreview = false;
        };
        var onFinally = (response) => {
          if (self.$refs.approve_logbook_btn) {
            self.$vs.loading.close(self.$refs.approve_logbook_btn.$el);
          }
        };
      
        self.$ajaxGet(self, `Assessor/AcceptLogbook/${self.selectedLogbook}`, onSuccess, onFinally);
      },
      getLogbookCount(){
        var self = this;

        self.logbookCountLoading = true;

        var onSuccess = function(response) {
          self.amountOfLogbooks = response.data
          self.logbookCountLoading = false;
        };

        if(self.chartCompanyDropdown){
          self.$ajaxGet(self, `Assessor/LogbookCount?moduleId=${this.chartmoduleDropdown.value}&companyId=${self.chartCompanyDropdown.value}` , onSuccess);
        }
        else{
          self.$ajaxGet(self, `Assessor/LogbookCount?moduleId=${this.chartmoduleDropdown.value}` , onSuccess);
        }
      },
    },
    mounted() {
      var self = this;
      self.loadModules();
      self.criteria.pageSize = self.pageSize;
      self.criteria.pageNumber = self.$refs.studentTable.currentPage;
      self.userIdFromLocalStorage = parseInt(localStorage.getItem("Current_User_Id"));
      self.getCompany();
      self.isMounted = true;
    },
  }

</script>
<style lang='scss'>
.info-icon-on-module{
  width: 30px;
  z-index: 5;
  text-align: justify;
  text-justify: inter-word
}

.info-next-to-checkcss{
  display: flex;

  .con-vs-checkbox{
    width: fit-content;
  }
}
#reasonText{
  resize: none !important;
}
.AssessorPopUp{
  margin: auto;
  width: fit-content;
  .Review-Dimensions-free{
    width: 100%;
  }
}
.assessment-Questions{
  width: fit-content !important;
  .popupCustomContent{
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}
.AssessorPopUp{
  margin: auto;
  width: fit-content;
  .Review-Dimensions-free{
    width: 100%;
  }
}
.assessment-Questions{
  width: fit-content !important;
  .popupCustomContent{
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}
.checkbox-relative{
  .pretty .state label{
    position: relative !important;
  }
}

.varccs-evaluation{
  width: 50% !important;
  .popupCustomContent{
    height: fit-content;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}


</style>
